import { gql } from '@apollo/client';

export const UPSERT_PERSON = gql`
  mutation UpsertPerson($input: UpsertStakeholderInput!) {
    people: upsertStakeholder(input: $input) {
      id
      firstName
    }
  }
`;
